module.exports = __webpack_public_path__ + "img/sy.ea70007a.png";